import enumeration from "./enumeration";

const BookingSource = {
  MEWS: "MEWS",
  CLOUDBEDS: "CLOUDBEDS",
  TICKETING: "TICKETING",
};

export default enumeration(BookingSource);
